import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, NavLink, useNavigate } from "react-router-dom";
import CurrencyFormat from "react-currency-format";

import logo from "../assets/images/logo.svg";
import { useTranslation } from "react-i18next";
import { logout } from "../api/users";
import { toastAlert } from "../lib/toastAlert";
import ProfileUpdateModal from "./AccountSettings/ProfileModal";
import { Offcanvas } from "react-bootstrap";
import isEmpty from "../lib/isEmpty";
import { toFixedDown, truncateDecimals } from "../lib/roundOf";

import { getStackingEstimate } from "../api/staking";
import { getLang, setLang } from "../lib/localStorage";
import { getAllOpenPosition } from "../api/tradeAction";
import SocketContext from "../context/SocketContext";
import { currencyChange } from "../lib/pairHelper";


export default function NavbarInnerSide({ toggleSidebar }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [ProfileModal, setProfileModal] = useState(false);
    const [tradedata, setTradeData] = useState();
    const [available, setTotalAvailable] = useState(0);
    const [totalPair, setTotalPair] = useState([]);
    const [equity, setEquity] = useState(0);
    const [arbitragePnl, setarbitragePnl] = useState(0);

    //redux
    const currency = useSelector((state) => state.currency);
    const walletData = useSelector((state) => state.wallet);
    const priceConversion = useSelector((state) => state.priceConversion);
    const availableBal = useSelector((state) => state.availableBal);
    const siteDoc = useSelector((state) => state.siteSetting);
    const pairListData = useSelector((state) => state.pairList);
    const marketPrice = useSelector((state) => state.marketPrice);
    const { isStake, isHedge, defaultcurrency, isTrade, isLiveEvents, profile, langCode } = useSelector((state) => state.account || {});



    // Offcanvas state
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const handleCloseOffcanvas = () => setShowOffcanvas(false);
    const handleShowOffcanvas = () => setShowOffcanvas(true);

    // Fetching unread notifications dynamically (similar to notification.js)
    const { unread } = useSelector((state) => state.notice || { unread: [] });




    // Fetching wallet balances dynamically (adjust state.wallet to your actual reducer mapping)
    // const {
    //     availableBal = 9200.43,
    //     stakedBal = 0.0,
    //     accountBal = 9200.43,
    //     totalPnL = -798.64,
    // } = useSelector((state) => state.wallet || {});

    // Helper to format currency
    const formatCurrency = (val) => {
        return Number(val).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };

    const handleTrade = () => { if (!isTrade) toastAlert("error", t("TRADE_ACCESS"), "login"); };
    const handleStake = () => { if (!isStake) toastAlert("error", t("STAKE_ACCESS"), "login"); };
    const handleLiveEvent = () => { if (!isLiveEvents) toastAlert("error", t("LIVE_EVENT_ACCESS"), "login"); };
    const handlehedge = () => { if (!isHedge) toastAlert("error", t("HEDGE_ACCESS"), "login"); };

    const handleCloseModal = () => { setProfileModal(false); };
    const getStackinginfo = async (spotPairId, type) => {
        try {
            const { status, result } = await getStackingEstimate(spotPairId);
            if (status == "success") {
                // console.log(result, "---------- reulst")
                if (!isEmpty(result)) {
                    if (defaultcurrency == "USD") {
                        setTradeData(result?.actStackToTalAmou);
                    } else {
                        let PriceChange =
                            priceConversion &&
                            priceConversion.length > 0 &&
                            priceConversion.find(
                                (el) =>
                                    el.baseSymbol == "USD" && el.convertSymbol == defaultcurrency,
                            );
                        if (PriceChange?.convertPrice) {
                            let totalbalance = !isEmpty(PriceChange?.convertPrice)
                                ? parseFloat(
                                    result?.actStackToTalAmou * PriceChange?.convertPrice,
                                )
                                : 0;
                            setTradeData(totalbalance);
                        }
                    }
                }
            } else {
                setTradeData(0);
            }
        } catch (err) {
            console.log(err, "errro");
        }
    };
    const handleAsset = async () => {
        try {
            let totalAmount = 0;
            let tempArr = [...walletData];

            currency?.length >= 0 &&
                currency.map((item, index) => {
                    let PriceCnv =
                        priceConversion &&
                        priceConversion.length > 0 &&
                        priceConversion.find(
                            (el) =>
                                el.baseSymbol == item.currencySymbol &&
                                el.convertSymbol == "USD",
                        );
                    let pairIndex =
                        tempArr &&
                        tempArr.findIndex((el) => {
                            return el._id == item._id;
                        });
                    if (pairIndex >= 0 && !isEmpty(pairIndex)) {
                        tempArr[pairIndex] = {
                            ...tempArr[pairIndex],
                            ...{
                                USDValue: !isEmpty(PriceCnv?.convertPrice)
                                    ? parseFloat(
                                        tempArr[pairIndex].stakeBal -
                                        tempArr[pairIndex].lockedBal,
                                    ) * parseFloat(PriceCnv?.convertPrice)
                                    : parseFloat(
                                        tempArr[pairIndex].stakeBal -
                                        tempArr[pairIndex].lockedBal,
                                    ),
                            },
                        };
                        totalAmount += tempArr[pairIndex].USDValue;
                    }
                });
            if (defaultcurrency == "USD") {
                setTotalAvailable(totalAmount);
                setarbitragePnl(availableBal?.profit);
            } else {
                let PriceChange =
                    priceConversion &&
                    priceConversion.length > 0 &&
                    priceConversion.find(
                        (el) =>
                            el.baseSymbol == "USD" && el.convertSymbol == defaultcurrency,
                    );
                if (PriceChange?.convertPrice) {
                    let totalbalance = !isEmpty(PriceChange?.convertPrice)
                        ? parseFloat(totalAmount * PriceChange?.convertPrice)
                        : 0;
                    let totalPNlL = !isEmpty(PriceChange?.convertPrice)
                        ? parseFloat(PriceChange?.convertPrice * availableBal?.profit)
                        : 0;
                    setTotalAvailable(totalbalance);
                    setarbitragePnl(totalPNlL);
                }
            }
        } catch (err) {
            console.log("err:------", err);
        }
    };
    useEffect(() => {
        if (
            !isEmpty(walletData) &&
            !isEmpty(currency) &&
            !isEmpty(priceConversion)
        ) {
            handleAsset();
            getStackinginfo();
        }
    }, [walletData, currency, priceConversion]);

    return (
        <>
            <ProfileUpdateModal isShow={ProfileModal} onHide={handleCloseModal} />
            <div className="w-full sm:h-[64px] bg-white border-b border-[#f4f3f3] flex justify-start items-start sticky top-0 z-50">
                <div className="xl:w-[263px] w-auto pl-4 xl:pr-6 pr-4 py-3 xl:border-r border-[#f4f3f3] flex flex-row justify-start items-center gap-4 shrink-0">
                    <div className="inline-flex justify-start items-center gap-3">
                        <Link to="/">
                            <img src={logo} alt="Logo" className="sm:h-[40px] h-[30px] w-auto" />
                        </Link>
                    </div>
                </div>
                <div className="flex-1 self-stretch pl-4 md:pl-6 pr-4 flex justify-end xl:justify-between items-center overflow-x-auto">
                    <div className="hidden xl:inline-flex flex-1 flex-col justify-start items-center gap-2.5">
                        <div className="p-2 bg-[#ACC6B8]/20 rounded inline-flex justify-start items-center gap-6">
                            <div className="pr-6 border-r border-[#6B7280]/25 flex justify-start items-center gap-2">
                                <div className="justify-center text-[#6B7280] text-sm font-normal font-['Roobert']">{t("AVAILABLE_BALANCE")}:</div>
                                {/* <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">$ {formatCurrency(availableBal)}</div> */}
                                <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">
                                    {" "}
                                    {currencyChange(defaultcurrency)}{" "}
                                    <CurrencyFormat
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        value={truncateDecimals(available, 2)}
                                    />
                                </div>
                            </div>
                            <div className="pr-6 border-r border-[#6B7280]/25 flex justify-start items-center gap-2">
                                <div className="justify-center text-[#6B7280] text-sm font-normal font-['Roobert']">{t("STAKED_BALANCE")}:</div>
                                {/* <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">$ {formatCurrency(0)}</div> */}
                                <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">
                                    {" "}
                                    {currencyChange(defaultcurrency)}{" "}
                                    <CurrencyFormat
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        value={truncateDecimals(tradedata, 2)}
                                    />
                                </div>
                            </div>
                            <div className="pr-6 border-r border-[#6B7280]/25 flex justify-start items-center gap-2">
                                <div className="justify-center text-[#6B7280] text-sm font-normal font-['Roobert']">{t("ACCOUNT_BALANCE")}:</div>
                                {/* <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">$ {formatCurrency(0)}</div> */}
                                <div className="justify-center text-[#395645] text-sm font-semibold font-['Roobert']">
                                    {currencyChange(defaultcurrency)}{" "}
                                    <CurrencyFormat
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        value={truncateDecimals(
                                            parseFloat(truncateDecimals(available, 2)) +
                                            parseFloat(truncateDecimals(tradedata, 2)),
                                            2
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="pr-6 flex justify-start items-center gap-2">
                                <div className="justify-center text-[#6B7280] text-sm font-normal font-['Roobert']">{t("TOTAL_PL")}:</div>
                                {/* <div className={`justify-center text-sm font-semibold font-['Roobert'] ${totalPNL < 0 ? 'text-red-500' : 'text-green-600'}`}>$ {formatCurrency(totalPNL)}</div> */}
                                <div className={`justify-center text-sm font-semibold font-['Roobert'] ${Number(arbitragePnl) < 0 ? 'text-red-500' : Number(arbitragePnl) > 0 ? 'text-green-600' : 'text-[#6B7280]'}`}>
                                    {" "}
                                    {currencyChange(defaultcurrency)}{" "}
                                    <CurrencyFormat
                                        displayType={"text"}
                                        thousandSeparator={true}
                                        value={truncateDecimals(arbitragePnl, 2)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex justify-start items-center gap-2">
                        <Link to="/notifications" className="hidden xl:flex w-10 h-10 relative rounded-full outline outline-1 outline-offset-[-1px] outline-[#395645]/10 justify-center items-center gap-2">
                            <div className="w-5 h-5 relative overflow-hidden">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.9173 15C12.9173 16.6108 11.6115 17.9167 10.0007 17.9167C8.38982 17.9167 7.08398 16.6108 7.08398 15" stroke="#395645" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M16.0259 15.0007H3.97406C3.15996 15.0007 2.5 14.3407 2.5 13.5266C2.5 13.1357 2.6553 12.7607 2.93174 12.4842L3.43443 11.9816C3.90327 11.5127 4.16667 10.8768 4.16667 10.2138V7.91732C4.16667 4.69566 6.77834 2.08398 10 2.08398C13.2217 2.08398 15.8333 4.69565 15.8333 7.91732V10.2138C15.8333 10.8768 16.0967 11.5127 16.5656 11.9816L17.0682 12.4842C17.3447 12.7607 17.5 13.1357 17.5 13.5266C17.5 14.3407 16.84 15.0007 16.0259 15.0007Z" stroke="#395645" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            {unread && unread.length > 0 && (
                                <div className="w-4 h-4 left-[26px] top-[-3.50px] absolute overflow-hidden">
                                    <div className="w-3.5 h-3.5 left-[1px] top-[1px] absolute bg-[#395645] rounded-full" />
                                    <div className="left-[5px] top-[1px] absolute justify-start text-white text-[10px] font-bold font-['Inter']">{unread.length}</div>
                                </div>
                            )}
                        </Link>
                        <Link to="/account-settings" className="hidden xl:flex w-10 h-10 bg-[#395645]/10 rounded-full justify-center items-center gap-2">
                            <img
                                alt="user profile"
                                className="img-fluid rounded-full"
                                src={
                                    profile
                                        ? profile
                                        : require("../assets/images/copy_usericon.png")
                                }
                                width={28}
                            />
                        </Link>
                        <button
                            className="xl:hidden block text-[#395645] focus:outline-none ml-2"
                            type="button"
                            onClick={handleShowOffcanvas}
                            aria-label="Toggle navigation"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="3" y1="12" x2="21" y2="12"></line>
                                <line x1="3" y1="6" x2="21" y2="6"></line>
                                <line x1="3" y1="18" x2="21" y2="18"></line>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>

            <Offcanvas
                show={showOffcanvas}
                onHide={handleCloseOffcanvas}
                placement="end"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title></Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="px-4 py-6">
                    <div className="ms-auto flex flex-col h-full">
                        {/* Balances Card */}
                        <ul className="navbar-nav mb-6 bg-[#395645]/5 border border-[#395645]/10 rounded-2xl p-5 flex flex-col gap-4 xl:hidden shadow-sm">
                            {siteDoc?.availableAccess && (
                                <li className="nav-item">
                                    <div className="mb-0 bal flex items-center justify-between w-full">
                                        <div className="tot font-medium text-[15px] opacity-80">{t("AVAILABLE_BALANCE")}&nbsp;:</div>
                                        <div className="font-bold text-[16px] tracking-tight">
                                            {" "}
                                            {currencyChange(defaultcurrency)}{" "}
                                            <CurrencyFormat
                                                displayType={"text"}
                                                thousandSeparator={true}
                                                value={truncateDecimals(available, 2)}
                                            />                                            </div>
                                    </div>
                                </li>
                            )}
                            {siteDoc?.stakeBalAccess && (
                                <li className="nav-item">
                                    <div className="mb-0 bal flex items-center justify-between w-full">
                                        <div className="tot font-medium text-[15px] opacity-80">{t("STAKED_BALANCE")}&nbsp;:</div>
                                        {/* <div className="font-bold text-[16px] tracking-tight">$ {formatCurrency(0)}</div> */}
                                        <div className="font-bold text-[16px] tracking-tight">
                                            {" "}
                                            {currencyChange(defaultcurrency)}{" "}
                                            <CurrencyFormat
                                                displayType={"text"}
                                                thousandSeparator={true}
                                                value={truncateDecimals(tradedata, 2)}
                                            />
                                        </div>
                                    </div>
                                </li>
                            )}
                            {siteDoc?.accountAccess && (
                                <li className="nav-item">
                                    <div className="mb-0 bal flex items-center justify-between w-full">
                                        <div className="tot font-medium text-[15px] opacity-80">{t("ACCOUNT_BALANCE")}1111&nbsp;:</div>
                                        {/* <div className="font-bold text-[16px] tracking-tight">$ {formatCurrency(0)}</div> */}
                                        <div className="font-bold text-[16px] tracking-tight">
                                            {currencyChange(defaultcurrency)}{" "}
                                            <CurrencyFormat
                                                displayType={"text"}
                                                thousandSeparator={true}
                                                value={truncateDecimals(
                                                    parseFloat(truncateDecimals(available, 2)) +
                                                    parseFloat(truncateDecimals(tradedata, 2)),
                                                    2
                                                )}
                                            />
                                        </div>
                                    </div>
                                </li>
                            )}
                            {siteDoc?.plAccess && (
                                <li className="nav-item pt-4 mt-1 border-t border-[#395645]/10">
                                    <div className="mb-0 bal flex items-center justify-between w-full">
                                        <div className="tot font-medium text-[15px] opacity-80">{t("TOTAL_PL")}:&nbsp;:</div>
                                        {/* <div className={`font-bold text-[16px] tracking-tight ${totalPNL < 0 ? 'text-[#ff6363]' : 'text-[#02a229]'}`}>$ {formatCurrency(totalPNL)}</div> */}
                                        <div className={`font-bold text-[16px] tracking-tight ${Number(arbitragePnl) < 0 ? 'text-red-500' : Number(arbitragePnl) > 0 ? 'text-[#02a229]' : 'text-[#6B7280]'}`}>
                                            {" "}
                                            {currencyChange(defaultcurrency)}{" "}
                                            <CurrencyFormat
                                                displayType={"text"}
                                                thousandSeparator={true}
                                                value={truncateDecimals(arbitragePnl, 2)}
                                            />
                                        </div>
                                    </div>
                                </li>
                            )}
                        </ul>

                        {/* Navigation Links */}
                        <ul className="navbar-nav mb-2 mb-xl-0 nav_after_login xl:hidden flex flex-col gap-1.5">
                            {siteDoc?.tradeAccess && (
                                <li className="nav-item">
                                    <NavLink to={isTrade ? "/trade" : "/"} className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors" onClick={() => { handleTrade(); handleCloseOffcanvas(); }}>
                                        <span className="font-medium text-[15px]">{t("TRADE")}</span>
                                    </NavLink>
                                </li>
                            )}
                            {siteDoc?.stakeAccess && (
                                <li className="nav-item">
                                    <Link className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors" to={isStake ? "/staking" : "/"} onClick={() => { handleStake(); handleCloseOffcanvas(); }}>
                                        <span className="font-medium text-[15px]">{t("STAKING")}</span>
                                    </Link>
                                </li>
                            )}
                            {siteDoc?.walletAccess && (
                                <li className="nav-item">
                                    <Link to="/wallet" className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors" onClick={handleCloseOffcanvas}>
                                        <span className="font-medium text-[15px]">{t("WALLET")}</span>
                                    </Link>
                                </li>
                            )}
                            {siteDoc?.transactionAccess && (
                                <li className="nav-item">
                                    <Link to="/transaction-history" className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors" onClick={handleCloseOffcanvas}>
                                        <span className="font-medium text-[15px]">{t("TRANSACTION")}</span>
                                    </Link>
                                </li>
                            )}
                            {siteDoc?.hedgeAccess && (
                                <li className="nav-item">
                                    <Link to={isHedge ? "/hedging" : "/"} onClick={() => { handlehedge(); handleCloseOffcanvas(); }} className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors">
                                        <span className="font-medium text-[15px]">{t("HEDGE_FUND")}</span>
                                    </Link>
                                </li>
                            )}
                            {siteDoc?.historyAccess && (
                                <li className="nav-item">
                                    <Link to="/stakinghistory" className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors" onClick={handleCloseOffcanvas}>
                                        <span className="font-medium text-[15px]">{t("STAKING_HISTORY")}</span>
                                    </Link>
                                </li>
                            )}
                            {siteDoc?.liveEventAccess && (
                                <li className="nav-item">
                                    <NavLink className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors" to={isLiveEvents ? "/live-events" : "/"} onClick={() => { handleLiveEvent(); handleCloseOffcanvas(); }}>
                                        <span className="font-medium text-[15px]">{t("LIVE_EVENTS")}</span>
                                    </NavLink>
                                </li>
                            )}

                            {/* Divider before account settings */}
                            <li className="my-2 border-t border-[#395645]/10"></li>

                            <li className="nav-item"><Link className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors" to="/account-settings" onClick={handleCloseOffcanvas}><span className="font-medium text-[15px]">{t("ACCOUNT_SETTINGS")}</span></Link></li>
                            <li className="nav-item"><Link className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors" onClick={() => { setProfileModal(true); handleCloseOffcanvas(); }}><span className="font-medium text-[15px]">{t("EDIT_PROFILE")}</span></Link></li>
                            <li className="nav-item"><Link className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors" to="/support-ticket" onClick={handleCloseOffcanvas}><span className="font-medium text-[15px]">{t("SUPPORT_TICKET")}</span></Link></li>
                            <li className="nav-item">
                                <Link className="nav-link relative flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors" to="/notifications" onClick={handleCloseOffcanvas}>
                                    <span className="font-medium text-[15px]">{t("NOTIFICATION")}</span>
                                    {unread && unread.length > 0 && (
                                        <span className="bg-[#d22102] text-white text-[11px] font-bold px-2 py-0.5 rounded-full min-w-[20px] text-center">{unread.length}</span>
                                    )}
                                </Link>
                            </li>
                            <li className="nav-item mt-2">
                                <Link className="nav-link flex items-center justify-between w-full px-4 py-3 rounded-xl hover:bg-[#395645]/5 transition-colors" onClick={() => { logout(navigate, dispatch, t); handleCloseOffcanvas(); }}>
                                    <span className="font-medium text-[15px]">{t("LOGOUT")}</span>
                                    {/* <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="opacity-70"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg> */}
                                </Link>
                            </li>
                        </ul>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}